import { render, staticRenderFns } from "./PageDataMatrixMain.vue?vue&type=template&id=003c2b66&scoped=true&"
import script from "./PageDataMatrixMain.vue?vue&type=script&lang=js&"
export * from "./PageDataMatrixMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c2b66",
  null
  
)

export default component.exports